<template>
    <v-container>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
          Keyboard & Mouse
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            <span v-for="(content, index) in contents" :key="content['id']">
               {{ section }}.{{ index + 1 }} {{ content.question }} <br>
               Answer: {{ forms.keyboard_score[index] ? 'Yes' : 'No' }} <br>
               Comment: {{ forms.keyboard_comment[index] }} <br> <br>
            </span>
        </div>
    </v-container>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section','forms'],
    data(){
        return{
       contents:[
                {
                    question:"When typing, are the employee’s wrist in neutral position (straight on home row & keyboard centered in front of user)?",
                    parts: ['Wrist']
                },
                {
                    question:"Is there a padded wrist rest?",
                    parts: ['Wrist']
                },
                {
                    question:"Are elbows maintained at 80-90 degrees?",
                    parts: ['Elbow']
                },
                {
                    question:"Is the mouse beside the keyboard at the same level as the keyboard?",
                    parts: ['General']
                }
            ]
        }
    },
    methods:{
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.keyboard_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

